import { Container } from './Container';
import { Button } from './Button';

const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '') || '';

const FOOTER_LINK = 'text-sm font-medium text-gch-text-secondary hover:text-white transition-colors whitespace-nowrap';

export function Footer() {
  return (
    <footer className="bg-gch-surface border-t border-gch-accent/15">
      <Container>
        <div className="pt-10 pb-6 flex flex-col items-center">
          <img src={`${base}/transSmilesFlowFavicon.png`} alt="SmilesFlow" className="h-10 w-10" />
          <div className="mt-4">
            <Button href="/studio/register">Get started free</Button>
          </div>
          <nav aria-label="quick links" className="mt-5">
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
              <a href="#channels" className={FOOTER_LINK}>Channels</a>
              <a href="#games" className={FOOTER_LINK}>Games</a>
              <a href="/pricing" className={FOOTER_LINK}>Pricing</a>
              <a href="#faq" className={FOOTER_LINK}>FAQ</a>
              <a href="/terms" className={FOOTER_LINK}>Terms</a>
              <a href="/privacy" className={FOOTER_LINK}>Privacy</a>
            </div>
          </nav>
        </div>
        <div className="border-t border-white/10 py-5 text-center">
          <p className="text-xs text-gch-text-muted">&copy; {new Date().getFullYear()} SmilesFlow. Play &bull; Compete &bull; Share.</p>
          <p className="mt-1.5 text-xs text-gch-text-muted">
            Support: <a href="mailto:support@smilesflow.com" className="hover:text-gch-accent">support@smilesflow.com</a>
          </p>
        </div>
      </Container>
    </footer>
  );
}
